
import { useState, useEffect, useCallback } from "react"
import GreenIcon from "../../assets/icons/map/LightBulbGreen.svg"
import RedIcon from "../../assets/icons/map/LightBulbRed.svg"
import GreyIcon from "../../assets/icons/map/LightBulbGrey.svg"
import GreySelectedIcon from "../../assets/icons/map/SelectedBulbGrey.svg"
import RedSelectedIcon from "../../assets/icons/map/SelectedBulbRed.svg"
import GreenSelectedIcon from "../../assets/icons/map/SelectedBulbGreen.svg"

const ASSET_STATUS = {
  RED: 'Y', GREEN: 'N',
}

const RED_STATUSES = ASSET_STATUS.RED

const NG_OWNER = 'National Grid'

/**
 * Returns Maps marker icon based on asset status
 * @param {*} asset 
 */
export const markerIcon = (asset, selected) => {
  let icon = GreyIcon
  let iconStatus = 1
  let anchorPosition = new window.google.maps.Point(0, 32)
  if(selected) {
    icon = GreySelectedIcon
    anchorPosition = new window.google.maps.Point(6, 38)
  }
  if (asset.ownership === NG_OWNER && asset.status === ASSET_STATUS.GREEN) {
    icon = GreenIcon
    iconStatus = 2
    if(selected) {
      icon = GreenSelectedIcon
      anchorPosition = new window.google.maps.Point(6, 38)
    }
  } else if (asset.ownership === NG_OWNER && RED_STATUSES.includes(asset.status)) {
    icon = RedIcon
    iconStatus = 3
    if(selected) {
      icon = RedSelectedIcon
      anchorPosition = new window.google.maps.Point(6, 38)
    }
  }

  return {
    url: icon,
    iconStatus: iconStatus,
    origin: new window.google.maps.Point(0, 0),
    anchor: anchorPosition,
  }
}

/**
 * Adds markers on the map
 * @param {*} map Google map object
 * @param {*} assets array of asset objects
 * @param {*} onMarkerClick function to call when marker is clicked
 */
const useAssetMap = (map, assets, setAsset, OnMarkerClick, nestModal, setNestModal, markerStatusValue, setMarkerStatus, setMarkerColor, history) => {
  
  const [ markers, setMarkers ] = useState([])

  const onclickOpen = useCallback(() => {
    setNestModal(true)
  }, [setNestModal])

  useEffect(() => {
    var infowindow
    if (map && assets) {
      // create markers for asssets passed and save state
      setMarkers(
        assets.map((asset) => {
          const icon = markerIcon(asset, false)
          
          const marker = new window.google.maps.Marker({
            map,
            icon,
            position: new window.google.maps.LatLng(asset.latitude, asset.longitude),
            title: `${asset.address.replace(/\s+/g, ' ')}`,
            data: asset,
          })
         
          marker.addListener("click", (ev) => {
            marker.setIcon(markerIcon(asset, true))
            if (infowindow) {
              infowindow.close()
            }
            infowindow = new window.google.maps.InfoWindow({
              pixelOffset: new window.google.maps.Size(-2, 0),
            })
            OnMarkerClick && OnMarkerClick(asset, setAsset, map, marker, icon, onclickOpen, nestModal, infowindow, setMarkerColor, history)
          })
          map.addListener("click",(ev) =>{
            if(marker.open){
              infowindow.close()
              marker.setIcon(markerIcon(false))
              marker.open = false
            }
          })
          return marker
        })
      )
    }
    return () => {
      markers &&
        markers.forEach((marker) => {
          marker.setMap(null)
        })
      setMarkers([])

    }
    // eslint-disable-next-line
  }, [map, assets, OnMarkerClick])
  return markers
}

export default useAssetMap
